import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { PutCrecaAccountsService } from "@/features/accounts/creca/services/put-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { usePutCrecaAccountStates } from "@/features/accounts/creca/hooks/use-put-accounts-states";
import { useContext } from "react";
import { MoneyLinkError, MoneyLinkException, ErrorLevel } from "@/shared/utils/custom-exception";


export const useUpdateCrecaAccounts = () => {
  const {
    crecaAccountId,
    accountSid,
    selectedStatus,
    isAggregate,
    setCrecaAccountId,
    setAccountSid,
    setSelectedStatus,
    setIsAggregate,
    isShowErrorDialog,
    setIsShowErrorDialog,
  } = usePutCrecaAccountStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const putCrecaAccountsService = new PutCrecaAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // クレカ更新
  const updateCrecaAccounts = async (
    accountGroupId: string,
    crecaAccountId: string,
    selectedStatus?: number,
    passbookName?: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await putCrecaAccountsService.putCrecaAccounts({
        account_group_id: accountGroupId,
        creca_account_id: crecaAccountId,
        ...(selectedStatus !== undefined && { selected_status: selectedStatus }),
        ...(passbookName !== undefined && { passbook_name: passbookName }),
      });
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("updateCrecaAccounts:", error);
      if (
        error instanceof MoneyLinkException &&
        error.error.props.reason === "webmoneylink_parameter_error"
      ) {
        throw new MoneyLinkException({
          error: new MoneyLinkError({
            level: ErrorLevel.Warn,
            code: error.error.props.code,
            reason: error.error.props.reason,
            messageTitle: undefined,
            messageBody:
              "Web明細帳名に使用できない文字が含まれているか、文字数が上限を超えています。\n入力内容をご確認ください。",
          }),
        });
      }
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    crecaAccountId,
    accountSid,
    selectedStatus,
    isAggregate,
    setCrecaAccountId,
    setAccountSid,
    setSelectedStatus,
    setIsAggregate,
    isShowErrorDialog,
    setIsShowErrorDialog,
    updateCrecaAccounts: errorHandledAsync(updateCrecaAccounts, setError),
  };
};
